import { Link } from 'react-router-dom';
import { decrypt } from '../../utils/encodingdecoding';
import { edsringMerchantId } from '../../utils';

export const COLUMNS = [
	{
		Header: 'Customer Code',
		Footer: 'Customer Code',
		accessor: 'customerCode',
	},

	{
		Header: 'Voucher Code',
		Footer: 'Voucher Code',
		accessor: 'vouchercode',
	},
	{
		Header: 'Voucher Name',
		Footer: 'Voucher Name',
		accessor: 'voucherName',
	},
	{
		Header: 'Value',
		Footer: 'Value',
		accessor: 'value',
	},

	{
		Header: 'Expiry Date',
		Footer: 'Expiry Date',
		accessor: 'expiredate',
	},
	...(decrypt(localStorage.getItem('Id')) === edsringMerchantId
		? [
			{
				Header: 'Remarks',
				Footer: 'Remarks',
				accessor: 'remarks',
			},
		]
		: []),

	{
		Header: 'Action',
		Footer: 'Action',
		accessor: 'action',
	},
];
